import { Timestamp } from '@angular/fire/firestore';

export interface Assignment {
  id: string | undefined;

  groupId: string;

  lessonId: string | undefined;
  lessonName: string | undefined;

  endDate?: Timestamp;

  gradeId: string | undefined;
  academicYear: number | undefined;

  type: AssignmentType;

  //   choices: ChoiceQuestion[];
  //   essay: EssayQuestion[];

  assignmentUrl: string | undefined;

  createdBy: string | undefined;
  createdById: string | undefined;

  created: Timestamp | undefined;
  modified: Timestamp | undefined;
}

// export interface ChoiceQuestion {
//   question: string;
//   options: string[];
//   answer: string;
// }

// export interface EssayQuestion {
//   question: string;
//   minWords: number;
//   maxWords: number;
// }

export enum AssignmentType {
  pdf = 'pdf',
  text = 'text',
}
